import { collect } from 'collect.js';
import { DAYS } from '../exports/Constants';
import WorkScheduleHelpers from './WorkScheduleHelpers';

class LocationHelpers {
  initLocation = (day, company) => ({
    day,
    hour: null,
    minute: null,
    name: null,
    start_time: null,
    address: company?.address,
    zip_code: company?.zip_code,
    city: company?.city,
    lat: company?.lat,
    lon: company?.lon,
  });

  initLocations = (company) =>
    collect(DAYS)
      .mapWithKeys((day) => [day, [this.initLocation(day, company)]])
      .when(company.locations && company.locations.length > 0, (items) =>
        items.merge(
          collect(company.locations)
            .mapToGroups((item) => [
              item.day,
              {
                ...item,
                start_time: WorkScheduleHelpers.formatHoursAndMinutes(item.hour, item.minute),
              },
            ])
            .all(),
        ),
      )
      .toArray();

  updateCoordinates = async (locations, country) => {
    const result = collect();

    for (const location of locations) {
      if (!location.address || !location.zip_code || !location.city) {
        result.push({
          ...location,
          lat: null,
          lon: null,
        });

        continue;
      }

      const { success, coordinates } = await this.getCoordinates(
        this.compileAddress(location.address, location.zip_code, location.city, country),
      );

      result.push({
        ...location,
        lat: success ? coordinates.lat() : location.lat,
        lon: success ? coordinates.lng() : location.lon,
      });
    }

    return result.toArray();
  };

  compileAddress = (address, zipCode, city, country) => `${address}, ${zipCode} ${city}, ${country}`;

  getCoordinates = async (address) => {
    if (!window.google?.maps) {
      return { success: false, coordinates: null };
    }

    try {
      const geocoder = new window.google.maps.Geocoder();

      const { results } = await geocoder.geocode({
        address,
      });

      const location = collect(results).first(
        (item) =>
          item.types.includes('street_address') ||
          item.types.includes('neighborhood') ||
          item.types.includes('premise') ||
          item.types.includes('subpremise') ||
          item.types.includes('route'),
      )?.geometry.location;

      return {
        success: !!location,
        coordinates: location,
      };
    } catch (e) {
      return {
        success: false,
        coordinates: null,
      };
    }
  };
}

export default new LocationHelpers();
